exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".custom-due-status{position:absolute;z-index:9999;top:-30%;left:104%;width:315px;height:230px}.custom-due-status .custom-group ul{padding:none;margin:none}.custom-due-status .custom-group ul li{list-style:none;width:290px}.custom-due-status .custom-group label{line-height:27px}.custom-due-status .custom-group .custom-input input{height:36px}.custom-due-status .custom-group .custom-input-to.rdtOpen .rdtPicker{top:-128%}.custom-due-status .rdtOpen .rdtPicker{position:absolute;top:0;left:100%}.custom-due-status .rdtOpen .rdtPicker:before,.custom-due-status .rdtOpen .rdtPicker:after{content:none}.custom-due-status .rdt .rdtPicker{transition:none}@media screen and (max-width: 767px){.custom-due-status{left:-4%;width:108%}}.custom-due-status.responsive{left:auto;right:104%}@media screen and (max-width: 767px){.custom-due-status.responsive{left:-4%;width:108%}}.custom-due-status:after{clear:both}.custom-item{position:relative}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/due-status/style.scss
// module id = 2064
// module chunks = 32